import React from "react";

const FapFalApiIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="48" height="48">
  <circle cx="50" cy="50" r="48.5" fill="#fff" stroke="#E4E4E7" strokeWidth="1.5"/>
  <g fill="none" stroke="#1E1A4D" strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M38 30c-6 0-8 3-8 8v5c0 4-2 7-6 7c4 0 6 3 6 7v5c0 5 2 8 8 8"/>
    <path d="M62 30c6 0 8 3 8 8v5c0 4 2 7 6 7c-4 0-6 3-6 7v5c0 5-2 8-8 8"/>
  </g>
  <path d="M50 38c1.2 6.2 5.8 10.8 12 12c-6.2 1.2-10.8 5.8-12 12c-1.2-6.2-5.8-10.8-12-12c6.2-1.2 10.8-5.8 12-12z" fill="#E0466E"/>
</svg>);

export default FapFalApiIcon;
